// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"tgAUV","rc-tabs-bar":"ctJA-","rc-tabs-tab":"_8B4tP","rc-tabs-tab-active":"hYaW5","terms":"+wNln","orderHistory-navigation":"YjXtE","container":"gLBQ8"};